var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.viewComponent,{tag:"component",attrs:{"id":_vm.messageLink.subject.subjectId,"opponent":_vm.opponent}})}
var staticRenderFns = []

export { render, staticRenderFns }